"use client";

import React, { useState, useMemo } from "react";
import { Play, Film, Sparkles, X, Maximize2 } from "lucide-react";
import { cn } from "@/lib/utils";
import { Button } from "@/components/ui/button";
import { Skeleton } from "@/components/ui/skeleton";
import { ScrollArea, ScrollBar } from "@/components/ui/scroll-area";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
const CATEGORIES = ["All", "CAD Models", "Wax Samples", "Finished Creations"];
type Poster = {
  id: string;
  title: string;
  category: string;
  image: string;
};
const POSTERS: Poster[] = [{
  id: "p1",
  title: "Geometric Solitaire",
  category: "CAD Models",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1670658/img/jewelry_cad_solitaire.png"
}, {
  id: "p2",
  title: "Intricate Halo Ring",
  category: "CAD Models",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1670658/img/jewelry_cad_halo.png"
}, {
  id: "p4",
  title: "Gold Ring Finish",
  category: "Finished Creations",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1670658/img/jewelry_gold_ring.png"
}, {
  id: "p5",
  title: "Art Deco Earrings",
  category: "CAD Models",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1670658/img/jewelry_cad_artdeco.png"
}, {
  id: "p6",
  title: "Gold Bracelet",
  category: "Wax Samples",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1670658/img/jewelry_gold_bracelet.png"
}, {
  id: "p7",
  title: "Emerald Cut Render",
  category: "CAD Models",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1670658/img/jewelry_cad_emerald.png"
}, {
  id: "p8",
  title: "Vintage Filigree",
  category: "Finished Creations",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1670658/img/jewelry_finished_filigree.png"
}, {
  id: "p10",
  title: "Bridal Set CAD",
  category: "CAD Models",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1670658/img/jewelry_cad_bridal.png"
}, {
  id: "p11",
  title: "Signet Ring Wax",
  category: "Wax Samples",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1670658/img/jewelry_wax_signet.png"
}, {
  id: "p12",
  title: "Diamond Pave Finish",
  category: "Finished Creations",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1670658/img/jewelry_finished_pave.png"
}, {
  id: "p13",
  title: "Architectural Band",
  category: "CAD Models",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1670658/img/jewelry_cad_architectural.png"
}, {
  id: "p15",
  title: "Sapphire Drop Finish",
  category: "Finished Creations",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1670658/img/jewelry_finished_sapphire.png"
}, {
  id: "p17",
  title: "Cluster Ring Wax",
  category: "Wax Samples",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1670658/img/jewelry_wax_cluster.png"
}, {
  id: "p18",
  title: "Gold Link Bracelet",
  category: "Finished Creations",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1670658/img/jewelry_finished_bracelet.png"
}, {
  id: "p19",
  title: "Tension Setting CAD",
  category: "CAD Models",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1670658/img/jewelry_cad_tension.png"
}, {
  id: "p20",
  title: "Eternity Band Wax",
  category: "Wax Samples",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1670658/img/jewelry_wax_eternity.png"
}, {
  id: "p21",
  title: "Marquise Halo Finish",
  category: "Finished Creations",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1670658/img/jewelry_finished_marquise.png"
}, {
  id: "p22",
  title: "Celtic Knot CAD",
  category: "CAD Models",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1670658/img/jewelry_cad_celtic.png"
}, {
  id: "p23",
  title: "Statement Piece Wax",
  category: "Wax Samples",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1670658/img/jewelry_wax_statement.png"
}, {
  id: "p24",
  title: "Rose Gold Pendant",
  category: "Finished Creations",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1670658/img/jewelry_finished_rosegold.png"
}, {
  id: "p25",
  title: "Men's Band CAD",
  category: "CAD Models",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1670658/img/jewelry_cad_mens.png"
}, {
  id: "p26",
  title: "Detailed Charm Wax",
  category: "Wax Samples",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1670658/img/jewelry_wax_charm.png"
}, {
  id: "p27",
  title: "Tennis Bracelet Finish",
  category: "Finished Creations",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1670658/img/jewelry_finished_tennis.png"
}, {
  id: "p28",
  title: "Abstract Ring CAD",
  category: "CAD Models",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1670658/img/jewelry_cad_abstract.png"
}, {
  id: "p30",
  title: "Custom Wedding Set",
  category: "Finished Creations",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1670658/img/jewelry_finished_wedding.png"
}];
const PosterCard = ({
  item,
  index,
  onView
}: {
  item: Poster;
  index: number;
  onView: (img: string) => void;
}) => {
  const [isLoaded, setIsLoaded] = useState(false);
  return <div data-index={index} className="group relative aspect-[4/5] w-full overflow-hidden rounded-md bg-muted/10 ring-1 ring-border/30 transition-all hover:ring-secondary/50 hover:shadow-xl">
      {!isLoaded && <Skeleton className="absolute inset-0 z-10 size-full rounded-md" />}
      <img src={item.image} data-wvc-srcset={`${item.image}-wvc-srcset`} data-wvc-sizes={`${item.image}-wvc-sizes`} alt={item.title} loading="lazy" onLoad={() => setIsLoaded(true)} className={cn("absolute inset-0 z-20 size-full object-cover transition-all duration-700 ease-out", isLoaded ? "scale-100 opacity-100" : "scale-105 opacity-0")} />
      
      <div className="absolute inset-0 z-30 flex flex-col justify-end bg-gradient-to-t from-background via-background/60 to-transparent p-4 opacity-0 transition-opacity duration-300 group-hover:opacity-100 backdrop-blur-[2px]">
        <div className="translate-y-4 transition-transform duration-300 group-hover:translate-y-0">
          <h4 className="font-default text-base font-bold leading-tight text-foreground line-clamp-2">
            {item.title}
          </h4>
          <p className="mt-1 text-xs font-mono font-medium text-secondary uppercase tracking-widest">
            {item.category}
          </p>
          <div className="mt-3 flex items-center gap-2">
            <Button size="sm" onClick={() => onView(item.image)} className="h-8 w-full rounded-md gap-1.5 font-semibold bg-secondary text-secondary-foreground hover:bg-secondary/90">
              <Maximize2 className="size-3.5" />
              View Larger
            </Button>
          </div>
        </div>
      </div>
    </div>;
};
export default function ExploreTheLibrary() {
  const [activeTab, setActiveTab] = useState("All");
  const [selectedImage, setSelectedImage] = useState<string | null>(null);
  const [modalOpen, setModalOpen] = useState(false);
  const filteredPosters = useMemo(() => {
    if (activeTab === "All") return POSTERS;
    return POSTERS.filter(poster => poster.category === activeTab);
  }, [activeTab]);
  const handleViewImage = (img: string) => {
    setSelectedImage(img);
    setModalOpen(true);
  };
  const closeModal = () => {
    setModalOpen(false);
    setSelectedImage(null);
  };
  return <section data-section-id="224668" id="the-gallery-of-work" className="relative bg-background text-foreground py-20 px-4 md:px-8 lg:px-12 overflow-hidden">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[400px] bg-secondary/5 blur-[120px] rounded-lg pointer-events-none" />

      <div className="relative z-10 mx-auto max-w-7xl flex flex-col h-full">
        <div className="mb-10 flex flex-col items-center text-center">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-md bg-secondary/10 text-secondary mb-4 border border-secondary/20">
            <Sparkles className="size-4" />
            <span className="text-xs font-mono font-bold uppercase tracking-widest">Digital Craftsmanship</span>
          </div>
          <h2 className="font-default text-4xl md:text-6xl font-bold tracking-tighter mb-4">
            The Gallery of <span className="text-transparent bg-clip-text bg-gradient-to-r from-primary via-secondary to-primary">Work</span>
          </h2>
          <p className="text-muted-foreground max-w-2xl text-lg font-default">
            A curated showcase of precision CAD models, high-resolution wax prototypes, and the final polished masterpieces.
          </p>
        </div>

        <Tabs defaultValue="All" value={activeTab} onValueChange={setActiveTab} className="w-full flex flex-col items-center">
          <div className="w-full overflow-x-auto pb-4 mb-6 flex justify-center hide-scrollbar">
            <TabsList className="bg-card/40 backdrop-blur-xl border border-border/50 rounded-md p-1.5 h-auto inline-flex shadow-2xl">
              {CATEGORIES.map((category, i) => <TabsTrigger key={category} value={category} data-index={i} className="rounded-md px-6 py-2.5 text-sm font-medium transition-all data-[state=active]:bg-secondary data-[state=active]:text-secondary-foreground data-[state=active]:shadow-md">
                  {category}
                </TabsTrigger>)}
            </TabsList>
          </div>

          <div className="w-full relative rounded-md border border-border/30 bg-card/30 backdrop-blur-md p-2 shadow-4xl">
            {CATEGORIES.map((category, i) => <TabsContent key={category} value={category} data-index={i} className="mt-0 outline-none">
                <ScrollArea className="h-[65vh] w-full rounded-md pr-4">
                  {filteredPosters.length > 0 ? <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-6 pb-8 pt-2">
                      {filteredPosters.map((poster, index) => <PosterCard key={poster.id} item={poster} index={index} onView={handleViewImage} />)}
                    </div> : <div className="flex flex-col items-center justify-center h-full text-muted-foreground py-20">
                      <Film className="size-12 mb-4 opacity-20" />
                      <p className="font-mono">No designs found in this category.</p>
                    </div>}
                  <ScrollBar className="bg-background/50 backdrop-blur-md" />
                </ScrollArea>
              </TabsContent>)}
            
            <div className="absolute bottom-2 left-2 right-6 h-12 bg-gradient-to-t from-background to-transparent pointer-events-none rounded-b-md" />
          </div>
        </Tabs>
      </div>

      {modalOpen && selectedImage && <div className="fixed inset-0 z-[100] flex items-center justify-center bg-background/90 backdrop-blur-xl p-4 md:p-10 animate-in fade-in duration-300" onClick={closeModal}>
          <Button variant="ghost" size="icon" className="absolute top-6 right-6 z-[110] text-foreground hover:bg-foreground/10 rounded-md" onClick={closeModal}>
            <X className="size-6" />
          </Button>
          <div className="relative max-w-5xl w-full max-h-full flex items-center justify-center" onClick={e => e.stopPropagation()}>
            <img src={selectedImage} data-wvc-srcset={`${selectedImage}-wvc-srcset`} data-wvc-sizes={`${selectedImage}-wvc-sizes`} alt="Enlarged view" className="max-w-full max-h-[85vh] object-contain rounded-md shadow-4xl ring-1 ring-border/50" />
          </div>
        </div>}
    </section>;
}